import styled from 'styled-components';
import {PageSize,HeaderSize,MainContainerSize,SidebarSize} from '../../Sizes';
import {BackgroundColor,DefaultPrimaryColor} from '../../Colors';
import patternImg from '../../images/wood-texture_00015.jpg';

const defaultStyle = {
	Header : styled.div`
		width:${HeaderSize.Width};
	`,
	Wrapper : styled.div`
		width : ${PageSize.Width};
		background-color : ${BackgroundColor};
		display : flex;
		flex-direction : column;
		&>:last-child{
			margin-top : auto;
		}
	`,
	Sidebar : styled.div`
		position : relative;
		${SidebarSize.Width};
	`,
	MainContainer : styled.div`
		position : relative;
		width: ${ ({isSidebarOpen}) =>  isSidebarOpen ? `calc(${PageSize.Width} - ${SidebarSize.Width})` : MainContainerSize.Width};
	`,
	Footer : styled.footer`
		width : 100%;
		border-top : 1px solid ${DefaultPrimaryColor};
		background-image : ${`url(${patternImg})`};
	`
};
export default defaultStyle;
